import React, { createContext, useContext, useEffect, useState } from "react";
const CacheContext = createContext();
export const CacheProvider = ({ children }) => {
  const [cache, setCache] = useState({});

  const fetchCacheData = (cacheKey) => {
    if (cache[cacheKey]) {
      console.log("Fetching from cache:", cacheKey);
      return cache[cacheKey];
    }
  };

  const setCacheData = (data, cacheKey) => {
     setCache((prevCache) => ({
        ...prevCache,
        [cacheKey]: data,
      }));
  }

   const removeCacheData = (cacheKey) => {
    setCache((prevCache) => {
      const newCache = { ...prevCache };
      delete newCache[cacheKey];
      return newCache;
    });
  };

  const reCallAPI = async (url, cacheKey) => {
    try {
      const response = await fetch(url);
      const data = await response.json();

      setCache((prevCache) => ({
        ...prevCache,
        [cacheKey]: data,
      }));

      console.log("Fetching from API:", cacheKey);
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw new Error("Error fetching data");
    }
  };

  return (
    <CacheContext.Provider value={{ reCallAPI, fetchCacheData, cache,setCacheData,removeCacheData }}>
      {children}
    </CacheContext.Provider>
  );
};

export const useCache = () => {
  return useContext(CacheContext);
};
